// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__hg1hf","rowHeader":"styles_rowHeader__60uB0","cell":"styles_cell__d95Fn","cellHeader":"styles_cellHeader__LrKBm","cellBody":"styles_cellBody__BtsNI"};